<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <v-layout mb-4>
                    <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
                        <span>แบบฟอร์ม</span>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <v-layout pa-6 mt-3 style="background-color: #3E7662;">
                            <v-flex d-flex justify-start align-center style="font-size: 28px;color: white">
                                <div style="font-weight: bold" @click="setData">หนังสือรับรอง ส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย</div>
                            </v-flex>
                            <v-flex d-flex justify-end align-center style="font-weight: bold;font-size: 13px;color: white">
                                <span>RL 04_2560</span>
                            </v-flex>
                        </v-layout>

                    <!-- Start Form -->

                        <!-- Start Card 1 -->
                        <v-card style="padding: 50px 100px 50px 100px">
                            <!-- Logo -->
                            <v-layout>
                                <v-flex>
                                    <img src="../../assets/LogoEN.png" width="124" alt="">
                                </v-flex>
                            </v-layout>

                            <!-- Header -->
                            <v-layout mt-4>
                                <v-flex>
                                    <div style="font-weight: bold;font-size: 20px;">The Institutional Review Board, Royal Thai Army Medical Department</div>
                                    <div style="font-weight: normal;font-size: 20px;">317/5 Rajavithi Road, Rajathevee, Bangkok 10400, Thailand </div>
                                    <div style="font-weight: normal;font-size: 20px;">Tel (662) 763-4297, (662) 763-4270, Fax(662) 354-9011,E-mail:irbrta@yahoo.com, irbrta@amed.go.th</div>
                                </v-flex>
                            </v-layout>

                            <!-- divider -->
                            <v-layout mt-8>
                                <v-flex>
                                    <v-divider style="background-color: #544A44;"></v-divider>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout mt-8>
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>No IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.enIRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.enIRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>Code :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    v-model="form.enCode"
                                                    placeholder="EC"
                                                    outlined
                                                    dense
                                                    color="#3E7662"
                                                    background-color="#FBF6F3"
                                                    hide-details
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Form Group -->
                            <v-layout py-12 mt-12>
                                <v-flex>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Title of Project</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enTitle"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enTitle', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Protocol No.</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    placeholder="(รหัสของบริษัทยา)"
                                                    :model="form.enProtocol"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enProtocol', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Principal Investigator</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enPrincipal"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enPrincipal', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Name of Department</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enDepartment"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enDepartment', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Study Site</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enStudySite"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enStudySite', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- เอกสารรับรอง -->
                            <v-layout>
                                <v-flex>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">Document Review</span><span style="font-size: 18px;"> : Protocol Amendment</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 1 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>1.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc1"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Version</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc1Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Dated</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date1"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange1"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date1')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 2 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>2.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc2"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Version</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc2Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Dated</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange2"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date2')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 3 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>3.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc3"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Version</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.enReviewDoc3Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>Dated</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date3"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange3"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date3')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Tag paragraph -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex class="text-start">
                                    <p style="text-indent: 10rem">
                                        The aforementioned amendment have been reviewed and approved by
                                        Committee on Human Right Related to Researches Involving Human Subjects.
                                        <v-text-field class="d-inline-block" style="width: 40rem;" color="#3E7662" hide-details />
                                    </p>
                                </v-flex>
                            </v-layout>

                            <!-- Form Date -->
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 100px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of amendment approval</span>
                                </v-flex>
                                <v-flex xs3 d-flex align-center class="text-start">
                                    <v-menu
                                            v-model="enApprovalDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="enApprovalDateChange"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'enApprovalDate')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;margin-bottom: 100px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of expiration</span>
                                </v-flex>
                                <v-flex xs3 d-flex align-center class="text-start">
                                    <v-menu
                                            v-model="enExpireDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="enExpireDateChange"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'enExpireDate')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <!--signature-->
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 100px">
                                <v-flex xs5 d-flex align-center class="text-start">
                                   <v-text-field
                                           v-model="form.enSignature"
                                           color="#3E7662"
                                           append-icon="edit"
                                   />
                                </v-flex>
                            </v-layout>
                            <v-layout style="padding-left: 80px; padding-right: 80px; margin-bottom: 150px;">
                                <v-flex xs5 style="font-weight: bold" class="text-start">
                                    <div>Colonel Suthee Panichkul, M.D.</div>
                                    <div>Chairperson,</div>
                                    <div>Institutional Review Board,</div>
                                    <div>Royal Thai Army Medical Department</div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>

                        </v-card>
                        <!--End Card 1 -->

                        <!-- Start Card 2 -->
                        <v-card class="mt-12"  style="padding: 50px 100px 50px 100px">
                            <!-- Logo -->
                            <v-layout>
                                <v-flex>
                                    <img src="../../assets/LogoTh.png" width="124" alt="">
                                </v-flex>
                            </v-layout>

                            <!-- Header -->
                            <v-layout mt-4>
                                <v-flex>
                                    <div style="font-weight: bold;font-size: 20px;">คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก</div>
                                    <div style="font-weight: normal;font-size: 20px;">ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า</div>
                                    <div style="font-weight: normal;font-size: 20px;">17/5ถนน ราชวิถีเขตราชเทวีกรุงเทพฯ 10400 โทรศัพท์, (662) 763-4297, (662) 763-4270โทรสาร (662) 354-9011</div>
                                    <div style="font-weight: normal;font-size: 20px;">www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/ E-mail; irbrta@yahoo.com, irbrta@amed.go.th </div>
                                </v-flex>
                            </v-layout>

                            <!-- divider -->
                            <v-layout mt-8>
                                <v-flex>
                                    <v-divider style="background-color: #544A44;"></v-divider>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout mt-8>
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>ที่ IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>รหัสโครงการ :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    v-model="form.thCode"
                                                    placeholder="EC"
                                                    outlined
                                                    dense
                                                    color="#3E7662"
                                                    background-color="#FBF6F3"
                                                    hide-details
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Form Group -->
                            <v-layout py-12 mt-12>
                                <v-flex>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อโครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textarea-form
                                                    :model="form.thTitle"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thTitle', $event)"
                                            ></textarea-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>เลขที่โครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    placeholder="(รหัสของบริษัทยา)"
                                                    :model="form.thProtocol"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thProtocol', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อผู้วิจัยหลัก</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thPrincipal"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thPrincipal', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>สังกัดหน่วยงาน</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thDepartment"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thDepartment', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>สถานที่ทําการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thStudySite"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thStudySite', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- เอกสารรับรอง -->
                            <v-layout>
                                <v-flex>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">เอกสารที่ทบทวน </span><span style="font-size: 18px;">: ส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 1 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>1.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc1"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc1Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date4"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange4"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date4')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 2 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>2.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc2"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc2Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date5"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange5"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date5')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 3 -->
                                    <v-layout pl-12 style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>3.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc3"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.thReviewDoc3Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date6"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange6"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date6')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Tag paragraph -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex class="text-start">
                                    <p style="text-indent: 10rem">
                                        คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก ได้พิจารณาส่วนแก้ไขเพิ่มเติม
                                        โครงร่างการวิจัยแล้ว จึงขอตอบรับและรับรองเอกสารดังกล่าว ผู้วิจัยสามารถดําเนินการตามโครงร่างการวิจัย
                                        ที่แก้ไขเพิ่มเติมได้ตั้งแต่วันที่ คณะอนุกรรมการฯ รับรอง
                                    </p>
                                </v-flex>
                            </v-layout>


                            <!--frequency-->
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 100px">
                                <v-flex pt-4 shrink d-flex align-center class="text-start" style="font-weight: bold">
                                    <span>วันที่รับรองส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย</span>
                                </v-flex>
                                <v-flex d-flex align-center class="text-start" style="padding-left: 15px;">
                                    <v-text-field
                                            v-model="form.thApprovalDate"
                                            color="#3E7662"
                                            hide-details
                                    />
                                </v-flex>
                            </v-layout>

                            <!--signature-->
                            <v-layout justify-space-between style="padding-left: 80px; padding-right: 80px;margin-top: 150px">
                                <v-flex xs5>
                                    <v-layout>
                                        <v-flex shrink pt-5 class="text-start">
                                            <span style="font-weight: bold;">พันเอก</span>
                                        </v-flex>
                                        <v-flex pl-2 d-flex align-center class="text-end">
                                            <v-text-field
                                                    v-model="form.thSignature"
                                                    color="#3E7662"
                                                    append-icon="edit"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex style="font-weight: bold">
                                            <div>(สุธีพานิชกุล)</div>
                                            <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัยพบ.</div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs5>
                                    <v-layout>
                                        <v-flex shrink pt-5 class="text-start">
                                            <span style="font-weight: bold;color: #CC3D45">ยศ</span>
                                        </v-flex>
                                        <v-flex pl-2 d-flex align-center class="text-end">
                                            <v-text-field
                                                    v-model="form.reviewerSignature"
                                                    color="#3E7662"
                                                    append-icon="edit"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex style="font-weight: bold">
                                            <div style="color: #CC3D45;">(ชื่อ-นามสกุล)</div>
                                            <div>อนุกรรมการพิจารณาโครงการวจิัย พบ.</div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>


                            <v-layout style="margin-top: 160px;">
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>

                        </v-card>
                        <!--End Card 2 -->

                    <!-- End Form -->

                        <!-- Button Save -->
                        <v-layout mt-8>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click.native="$router.go(-1)">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
<!--                                            <v-icon class="mr-3">add</v-icon>-->
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-pageAndLine="fullpageAndLine"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
    import { mapState } from "vuex";

    export default {
        name: "FormRF06",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
            TextfieldFormAppend,
        },
        data: () => ({
            isLoading: false,
            fullpageAndLine: true,
            menu_date1: false,
            menu_date2: false,
            menu_date3: false,
            menu_date4: false,
            menu_date5: false,
            menu_date6: false,
            enApprovalDate: false,
            enExpireDate: false,
            disabled: false,
            form: {
                researchID:'',
                enIRBTABefore:'',
                enIRBTAAfter:'',
                enCode:'',
                enTitle:'',
                enProtocol:'',
                enPrincipal:'',
                enDepartment:'',
                enStudySite:'',
                enReviewDoc1:'',
                enReviewDoc1Version:'',
                enReviewDoc1Date:'',
                enReviewDoc2:'',
                enReviewDoc2Version:'',
                enReviewDoc2Date:'',
                enReviewDoc3:'',
                enReviewDoc3Version:'',
                enReviewDoc3Date:'',
                enApprovalDate:'',
                enExpireDate:'',
                enSignature:'',
                thIRBTABefore:'',
                thIRBTAAfter:'',
                thCode:'',
                thTitle:'',
                thProtocol:'',
                thPrincipal:'',
                thDepartment:'',
                thStudySite:'',
                thReviewDoc1:'',
                thReviewDoc1Version:'',
                thReviewDoc1Date:'',
                thReviewDoc2:'',
                thReviewDoc2Version:'',
                thReviewDoc2Date:'',
                thReviewDoc3:'',
                thReviewDoc3Version:'',
                thReviewDoc3Date:'',
                thApprovalDate:'',
                thSignature:'',
                reviewerSignature:'',
            },
            enApprovalDateChange:'',
            enExpireDateChange:'',
            dateChange1: '',
            dateChange2: '',
            dateChange3: '',
            dateChange4: '',
            dateChange5: '',
            dateChange6: '',
        }),
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        created() {
            // Check Permission Access
         //   if (this.user.currentRole !== 3 && this.user.currentRole !== 4) {
         //       this.$router.go(-1);
         //   }
            this.getRL04();
        },
        methods:{
            updateData(name, val) {
                this.form[name] = val;
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        this.$store.dispatch("FormRL/saveRL04", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.isLoading = false;
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // })
                            // this.isLoading = false;
                        })
                    }
                });
            },
            getRL04() {
                this.isLoading = true;
                this.$store.dispatch("FormRL/getRL04", this.$route.query.id).then(res => {
                    // console.log('getRL01 : ' ,res);
                    this.form.researchID = res.researchID;
                    this.form.enIRBTABefore = res.enIRBTABefore;
                    this.form.enIRBTAAfter = res.enIRBTAAfter;
                    this.form.enCode = res.enCode;
                    this.form.enTitle = res.enTitle;
                    this.form.enProtocol = res.enProtocol;
                    this.form.enPrincipal = res.enPrincipal;
                    this.form.enDepartment = res.enDepartment;
                    this.form.enStudySite = res.enStudySite;
                    this.form.enReviewDoc1 = res.enReviewDoc1;
                    this.form.enReviewDoc1Version = res.enReviewDoc1Version;
                    this.selectDate(res.enReviewDoc1Date,'menu_date1');
                    this.form.enReviewDoc1Date = res.enReviewDoc1Date;
                    this.form.enReviewDoc2 = res.enReviewDoc2;
                    this.form.enReviewDoc2Version = res.enReviewDoc2Version;
                    this.selectDate(res.enReviewDoc2Date,'menu_date2');
                    this.form.enReviewDoc2Date = res.enReviewDoc2Date;
                    this.form.enReviewDoc3 = res.enReviewDoc3;
                    this.form.enReviewDoc3Version = res.enReviewDoc3Version;
                    this.selectDate(res.enReviewDoc3Date,'menu_date3');
                    this.form.enReviewDoc3Date = res.enReviewDoc3Date;
                    this.form.enApprovalDate = res.enApprovalDate;
                    this.form.enExpireDate = res.enExpireDate;
                    this.form.enSignature = res.enSignature;
                    this.form.thIRBTABefore = res.thIRBTABefore;
                    this.form.thIRBTAAfter = res.thIRBTAAfter;
                    this.form.thCode = res.thCode;
                    this.form.thTitle = res.thTitle;
                    this.form.thProtocol = res.thProtocol;
                    this.form.thPrincipal = res.thPrincipal;
                    this.form.thDepartment = res.thDepartment;
                    this.form.thStudySite = res.thStudySite;
                    this.form.thReviewDoc1 = res.thReviewDoc1;
                    this.form.thReviewDoc1Version = res.thReviewDoc1Version;
                    this.selectDate(res.thReviewDoc1Date,'menu_date4');
                    this.form.thReviewDoc1Date = res.thReviewDoc1Date;
                    this.form.thReviewDoc2 = res.thReviewDoc2;
                    this.form.thReviewDoc2Version = res.thReviewDoc2Version;
                    this.selectDate(res.thReviewDoc2Date,'menu_date5');
                    this.form.thReviewDoc2Date = res.thReviewDoc2Date;
                    this.form.thReviewDoc3 = res.thReviewDoc3;
                    this.form.thReviewDoc3Version = res.thReviewDoc3Version;
                    this.selectDate(res.thReviewDoc3Date,'menu_date6');
                    this.form.thReviewDoc3Date = res.thReviewDoc3Date;
                    this.form.thApprovalDate = res.thApprovalDate;
                    this.form.thSignature = res.thSignature;
                    this.form.reviewerSignature = res.reviewerSignature;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
                // todo save form RL01
            },
            selectDate(val,name) {
                if (name === 'menu_date1') {
                    this.menu_date1 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange1 = changeDate;
                    this.form.enReviewDoc1Date = val;
                }
                if (name === 'menu_date2') {
                    this.menu_date2 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange2 = changeDate;
                    this.form.enReviewDoc2Date = val;
                }
                if (name === 'menu_date3') {
                    this.menu_date3 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange3 = changeDate;
                    this.form.enReviewDoc3Date = val;
                }
                if (name === 'menu_date4') {
                    this.menu_date4 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange4 = changeDate;
                    this.form.thReviewDoc1Date = val;
                }
                if (name === 'menu_date5') {
                    this.menu_date5 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange5 = changeDate;
                    this.form.thReviewDoc2Date = val;
                }
                if (name === 'menu_date6') {
                    this.menu_date6 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange6 = changeDate;
                    this.form.thReviewDoc3Date = val;
                }
                if (name === 'enApprovalDate') {
                    this.enApprovalDate = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.enApprovalDateChange = changeDate;
                    this.form.enApprovalDate = val;
                }
                if (name === 'enExpireDate') {
                    this.enExpireDate = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.enExpireDateChange = changeDate;
                    this.form.enExpireDate = val;
                }
            },
            // Change Date
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);

                sub_year = parseInt(sub_year)+543;

                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },

            setData() {
                this.form.enIRBTABefore ='Test';
                this.form.enIRBTAAfter ='Test';
                this.form.enCode ='Test';
                this.form.enTitle ='Test';
                this.form.enProtocol = 'Test';
                this.form.enPrincipal = 'Test';
                this.form.enDepartment = 'Test';
                this.form.enStudySite = 'Test';
                this.form.enReviewDoc1 = 'Test';
                this.form.enReviewDoc1Version = 'Test';
                this.form.enReviewDoc1Date = '2020-02-12';
                this.form.enReviewDoc2 = 'Test';
                this.form.enReviewDoc2Version = 'Test';
                this.form.enReviewDoc2Date = '2020-02-12';
                this.form.enReviewDoc3 = 'Test';
                this.form.enReviewDoc3Version = 'Test';
                this.form.enReviewDoc3Date = '2020-02-12';
                this.form.enApprovalDate = '2020-02-12';
                this.form.enExpireDate = '2020-02-12';
                this.form.enSignature = 'Test';
                this.form.thIRBTABefore = 'Test';
                this.form.thIRBTAAfter = 'Test';
                this.form.thCode = 'Test';
                this.form.thTitle = 'Test';
                this.form.thProtocol = 'Test';
                this.form.thPrincipal = 'Test';
                this.form.thDepartment = 'Test';
                this.form.thStudySite = 'Test';
                this.form.thReviewDoc1 = 'Test';
                this.form.thReviewDoc1Version = 'Test';
                this.form.thReviewDoc1Date = '2020-02-12';
                this.form.thReviewDoc2 = 'Test';
                this.form.thReviewDoc2Version = 'Test';
                this.form.thReviewDoc2Date = '2020-02-12';
                this.form.thReviewDoc3 = 'Test';
                this.form.thReviewDoc3Version = 'Test';
                this.form.thReviewDoc3Date = '2020-02-12';
                this.form.thApprovalDate = '2020-02-12';
                this.form.thSignature = 'Test';
                this.form.reviewerSignature = 'Test';
            },
        },
    }
</script>

<style lang="scss">
    /*** Table Styles **/
    .table-style {
        .table-fill {
            background: white;
            border-radius:3px;
            border-collapse: collapse;
            margin: auto;
            padding:5px;
            width: 100%;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            animation: float 5s infinite;
            border-bottom: 5px solid #544A44;
        }

        th {
            color:#D5DDE5;;
            background:#3E7662;
            border-top:5px solid #544A44;
            border-right: 1px solid #544A44;
            font-weight: 700;
            padding:15px;
            vertical-align:middle;
        }

        /*th:first-child {*/
        /*    border-top-left-radius:3px;*/
        /*}*/

        th:last-child {
            border-top-right-radius:3px;
            border-right:none;
        }

        tr {
            border-top: 1px solid #544A44;
            border-bottom-: 1px solid #544A44;
            color:#ffffff;
        }

        /*tr:hover td {*/
        /*    background:#4E5066;*/
        /*    color:#FFFFFF;*/
        /*    border-top: 1px solid #22262e;*/
        /*}*/

        tr:first-child {
            border-top:none;
        }

        tr:last-child {
            /*border-bottom:5px solid #544A44;*/
        }

        /*tr:nth-child(odd) td {*/
        /*    background:#EBEBEB;*/
        /*}*/

        /*tr:nth-child(odd):hover td {*/
        /*    background:#4E5066;*/
        /*}*/

        tr:last-child td:first-child {
            border-bottom-left-radius:3px;
        }

        tr:last-child td:last-child {
            border-bottom-right-radius:3px;
        }

        td {
            background:#FFFFFF;
            padding:10px 30px 10px 30px;
            text-align:left;
            vertical-align:middle;
            font-weight:700;
            color: black;
            border-right: 1px solid #544A44;
        }

        td:last-child {
            border-right: 0px;
        }

        th.text-left {
            text-align: left;
        }

        th.text-center {
            text-align: center;
        }

        th.text-right {
            text-align: right;
        }

        td.text-left {
            text-align: left;
        }

        td.text-center {
            text-align: center;
        }

        td.text-right {
            text-align: right;
        }
    }
    .text-field-color {
         .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
             color: #CC3D45;
         }
    }
    .text-field-margin {
        .v-text-field {
            padding: 0;
            margin: 0;
        }
    }


</style>